<template>
  <div class="pie">
    <!-- 为 ECharts 准备一个具备大小（宽高）的 DOM -->
    <div id="main2"
         ref="main2"
         style="float:left;width:100%;height: 200px"></div>
  </div>
</template>
 
<script>
var echarts = require('echarts');

export default {
  props: ['dataList1'],
  data () {
    return {
      // 数据
      dom: null,
    }
  },
  computed: {
    options () {
      let that = this;
      let option = {
        series: [
          {
            type: 'gauge',
            radius: '100%',
            center: ["50%", "70%"],
            startAngle: '180',
            endAngle: '0',
            pointer: {
              show: false
            },
            detail: {
              formatter: function (value) {
                var num = Math.round(value);
                let str = ''
                if (num == 90) {
                  str = '高风险'
                } else if (num == 60) {
                  str = "中风险"
                } else if (num == 0) {
                  str = '无风险'
                }
                return '{bule|' + str + '}' + '{size|' + '}';
                // return '{bule|' + str + '}{white|分}' + '{size|' + '}';
              },
              fontSize: 12,
              rich: {
                white: {
                  fontSize: 20,
                  color: '#fff',
                  fontWeight: '500',
                  padding: [20, 0, 0, 0]
                },
                bule: {
                  fontSize: 20,
                  fontFamily: 'DINBold',
                  color: '#fff',
                  fontWeight: '700',
                  padding: [20, 0, 0, 0],
                },
                size: {
                  height: 400,
                  padding: [100, 0, 0, 0]
                }
              },
              "offsetCenter": ['0%', "-25%"],
            },
            data: [{
              value: 31,
              name: '综合健康评分'
            }],
            title: {
              offsetCenter: ['0', '-15%'],       // x, y，单位px
              fontSize: 12,
              color: '#979DAE'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: [
                  [0.71, new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                    offset: 0,
                    color: '#5CF9FE' // 0% 处的颜色
                  },
                  {
                    offset: 0.17,
                    color: '#468EFD' // 100% 处的颜色
                  },
                  {
                    offset: 0.9,
                    color: '#468EFD' // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#5CF9FE' // 100% 处的颜色
                  }
                  ])],
                  [1, '#4D4D57']
                ],
                width: 10,
                // shadowBlur: 15,
                // shadowColor: '#B0C4DE',
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                opacity: 1
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false,
              length: 15,
              lineStyle: {
                color: '#00377a',
                width: 2,
                type: 'solid',
              },
            },
            axisLabel: {
              show: false
            },
          },
          {
            name: '灰色内圈', //刻度背景
            type: 'gauge',
            center: ["50%", "70%"],
            z: 2,
            radius: '80%',
            startAngle: '180',
            endAngle: '0',
            //center: ["50%", "75%"], //整体的位置设置
            axisLine: { // 坐标轴线
              lineStyle: { // 属性lineStyle控制线条样式
                color: [
                  [1, '#4D4D57']
                ],
                width: 2,
                opacity: 1, //刻度背景宽度
              }
            },
            splitLine: {
              show: false
            },
            title: {
              offsetCenter: ['0', '60%'],       // x, y，单位px
              fontSize: 12,
              color: '#979DAE'
            },
            // data: [{
            //     show: false,
            //     value: '80'
            // }], //作用不清楚
            axisLabel: {
              show: false
            },
            pointer: {
              show: false
            },
            axisTick: {
              show: false
            },
            detail: {
              show: 0
            }
          },
          {
            name: "白色圈刻度",
            type: "gauge",
            radius: "80%",
            center: ["50%", "70%"],
            startAngle: 180, //刻度起始
            endAngle: 0, //刻度结束
            z: 4,
            axisTick: {
              show: false
            },
            splitLine: {
              length: 6, //刻度节点线长度
              lineStyle: {
                width: 2,
                color: '#4D4D57'
              } //刻度节点线
            },
            axisLabel: {
              color: 'rgba(255,255,255,0)',
              fontSize: 12,
            }, //刻度节点文字颜色
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                opacity: 0,
              }
            },
            detail: {
              show: false
            },
            data: [{
              value: 0,
              name: ""
            }]
          },

        ]
      };
      return option;

    }
  },
  mounted () {
    this.initData();
    window.addEventListener('resize', this.options)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.options)
  },
  watch: {
    dataList1: {
      handler (newVal, oldVal) {
        this.initData();
      },
      deep: true
    }
  },
  methods: {
    resize () {
      this.dom.resize();
    },
    //初始化数据
    initData () {
      var myChart = echarts.init(document.getElementById('main2'));
      console.log(this.dataList1);
      let num = this.dataList1[0].value;
      if (num == 90) {
        this.options.series[0].axisLine.lineStyle.color = [
          [0.71, new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
            offset: 0,
            color: '#5CF9FE' // 0% 处的颜色
          },
          {
            offset: 0.17,
            color: '#468EFD' // 100% 处的颜色
          },
          {
            offset: 0.9,
            color: '#468EFD' // 100% 处的颜色
          },
          {
            offset: 1,
            color: '#5CF9FE' // 100% 处的颜色
          }
          ])],
          [1, '#4D4D57']
        ]
      } else if (num == 60) {
        this.options.series[0].axisLine.lineStyle.color = [
          [0.41, new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
            offset: 0,
            color: '#5CF9FE' // 0% 处的颜色
          },
          {
            offset: 0.17,
            color: '#468EFD' // 100% 处的颜色
          },
          {
            offset: 0.9,
            color: '#468EFD' // 100% 处的颜色
          },
          {
            offset: 1,
            color: '#5CF9FE' // 100% 处的颜色
          }
          ])],
          [1, '#4D4D57']
        ]
      } else if (num == 0) {
        this.options.series[0].axisLine.lineStyle.color = [
          [0, new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
            offset: 0,
            color: '#5CF9FE' // 0% 处的颜色
          },
          {
            offset: 0.17,
            color: '#468EFD' // 100% 处的颜色
          },
          {
            offset: 0.9,
            color: '#468EFD' // 100% 处的颜色
          },
          {
            offset: 1,
            color: '#5CF9FE' // 100% 处的颜色
          }
          ])],
          [1, '#4D4D57']
        ]
      }
      this.options.series[0].data = this.dataList1;
      // 绘制图表
      myChart.setOption(this.options);
    },
  }
}
</script>